/* eslint-disable */
import React from 'react';
import {
    Datagrid,
    TextField,
    TextInput,
    List,
    ReferenceInput,
    AutocompleteInput,
    ReferenceField,
    Filter,
    SelectInput,
} from 'react-admin';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { SwList } from '../../lib/SwList';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { CloneButton } from '../../lib/wrappers/actions';

const AssociateCourseList = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
            <SwList {...props} filters={<AssociateCourseFilters />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={
                        !canEditCourseAndModule ? false : undefined
                    }
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                    <TextField source="certificateTitle" />
                    <ReferenceField reference="Status" source="statusId">
                        <TextField source="Title" />
                    </ReferenceField>
                    <CloneButton label="myroot.copy" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

const AssociateCourseFilters = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <TextInput label="Title" source="Title" />
        <TextInput label="ID" source="id" />
        <ReferenceInput label="Module" reference="Module" source="moduleIds">
            <AutocompleteInput optionText="shortTitle" />
        </ReferenceInput>
        <ReferenceInput label="Faculty" reference="Faculty" source="facultyId">
            <AutocompleteInput optionText="description" />
        </ReferenceInput>
        <ReferenceInput reference="CourseLevel" source="courseLevelId">
            <AutocompleteInput optionText="description" />
        </ReferenceInput>
        <ReferenceInput reference="Status" source="statusId">
            <SelectInput optionText="Title" />
        </ReferenceInput>
    </Filter>
);

export default AssociateCourseList;
